import React from 'react';
import { ApprovalBanner } from './components/ApprovalBanner';
import { ResidencyQuestion } from './components/ResidencyQuestion';
import { TrustBadges } from './components/TrustBadges';
import { RecentCustomers } from './components/RecentCustomers';
import { ExitIntentPopup } from './components/ExitIntentPopup';
export function App() {
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-green-200 selection:text-green-900 flex flex-col" data-id="element-0">
      {/* Top sticky banner */}
      <ApprovalBanner data-id="element-1" />

      {/* Main content area */}
      <main className="flex-1 flex flex-col" data-id="element-2">
        {/* Qualifier Question & Legal Links */}
        <ResidencyQuestion data-id="element-3" />

        {/* Trust & Review Badges */}
        <TrustBadges data-id="element-4" />

        {/* Recent Customers Social Proof */}
        <RecentCustomers data-id="element-5" />
      </main>

      {/* Simple Footer */}
      <footer className="bg-gray-900 text-gray-400 py-8 text-center text-sm" data-id="element-6">
        <div className="max-w-4xl mx-auto px-4" data-id="element-7">
          <p data-id="element-8">© 2026 Bathroom Remodel Service. All rights reserved.</p>
          <p className="mt-2 text-xs text-gray-500" data-id="element-9">
            This site is a free matching service to connect homeowners with
            local contractors. We do not perform remodeling services directly.
          </p>
        </div>
      </footer>

      {/* Exit Intent Popup */}
      <ExitIntentPopup data-id="element-10" />
    </div>;
}